import script from "./CarAtenVue.vue?vue&type=script&lang=ts&setup=true"
export * from "./CarAtenVue.vue?vue&type=script&lang=ts&setup=true"

import "./CarAtenVue.vue?vue&type=style&index=0&id=f1de2046&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f1de2046"]])

export default __exports__